'use strict';

angular.module('amexReconciliationApp')
  .service('SelectedTransactionService', function (TransactionSearchModel,
                                                   $rootScope,
                                                   TransactionsModel,
                                                   TransactionFilterModel,
                                                   TransactionTabFilterModel,
                                                   $q) {
    var self = this;
    self.selectedTransactionIds = [];
    self.lockedTransactionIds = [];
    self.partiallyLockedTransactionIds = [];

    self.addTransaction = function addTransaction(transaction) {
      self.selectedTransactionIds.push(transaction.id);

      if (isFullyLocked(transaction)) {
        self.lockedTransactionIds.push(transaction.id);
      }
      if (isPartiallyLocked(transaction)) {
        self.partiallyLockedTransactionIds.push(transaction.id);
      }
    };

    function isFullyLocked(transaction) {
      return transaction.lockStatus === 'FULLY_LOCKED';
    }

    function isPartiallyLocked(transaction) {
      return transaction.lockStatus === 'PARTIALLY_LOCKED';
    }

    self.anyFullyLockedSelected = function () {
      return self.lockedTransactionIds.length > 0;
    };

    self.anyPartiallyLockedSelected = function () {
      return self.partiallyLockedTransactionIds.length > 0;
    };

    self.addTransactions = function addTransactions(newTransactions) {
      return $q.all(_.map(newTransactions, self.addTransaction));
    };

    self.selectedTransactions = function () {
      return _.filter(TransactionsModel.transactions(), self.isSelected);
    };

    self.selectedTransactionsByCurrency = function (currency) {
      var transactionCurrency = _.find(TransactionsModel.transactionCurrency(), ['key', currency]);
      return _.filter(transactionCurrency.value, self.isSelected);
    };

    self.removeTransaction = function (transaction) {
      self.selectedTransactionIds = _.reject(self.selectedTransactionIds, equalTo(transaction.id));
      self.lockedTransactionIds = _.reject(self.lockedTransactionIds, equalTo(transaction.id));
      self.partiallyLockedTransactionIds = _.reject(self.partiallyLockedTransactionIds, equalTo(transaction.id));
    };

    self.selectedTransactionsCount = function () {
      return self.selectedTransactionIds.length;
    };

    self.selectedTransactionsSum = function () {
      return _.sumBy(self.selectedTransactions(), _.property('amount'));
    };

    self.selectedTransactionsMultiCurrencySum = function (currency) {
      return _.sumBy(self.selectedTransactionsByCurrency(currency), _.property('amount'));
    };

    self.removeAll = function () {
      self.selectedTransactionIds = [];
      self.lockedTransactionIds = [];
      self.partiallyLockedTransactionIds = [];
    };

    self.removeNonVisibleTransactions = function () {
      var newSelectedTransactions = _.intersectionWith(self.selectedTransactionIds, TransactionFilterModel.transactions(), function (selectedId, filtered) {
        return selectedId === filtered.id;
      });

      self.selectedTransactionIds = newSelectedTransactions;
    };

    self.anyReallocatedTransaction = function(){
      return _.some(self.selectedTransactions(),['mutableTransactionProperties.transactionStatus', 'REALLOCATED']);
    };

    self.isSelected = function (transaction) {
      return _.some(self.selectedTransactionIds, equalTo(transaction.id));
    };

    function equalTo(needle) {
      return function (candidate) {
        return candidate === needle;
      };
    }

    TransactionSearchModel.onParamsChanged($rootScope, self.removeAll);
    TransactionTabFilterModel.onActiveTabChanged($rootScope, self.removeAll);
    TransactionFilterModel.onFilterChanged($rootScope, self.removeAll);
    TransactionFilterModel.onTransactionsChanged($rootScope, self.removeNonVisibleTransactions);
    TransactionsModel.onTransactionsChanged($rootScope, function (newTransactions) {
      if (newTransactions.length < 1) {
        self.removeAll();
      }
    });
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/SelectedTransactionService.js
// module id = 645
// module chunks = 0